import React from 'react';
import ReactDOM from 'react-dom';
import Services, { Service } from './Services';

it('renders without crashing', () => {
  const div = document.createElement('div');
  ReactDOM.render(
    <Services heading="My Heading">
        <Service md="6" icon="fa-wrench" heading="My Heading" description="My awesome description"/>
        <Service md="6" icon="fa-wrench" heading="My Heading" description="My awesome description"/>
    </Services>, 
  div);
  ReactDOM.unmountComponentAtNode(div);
});



// WEBPACK FOOTER //
// ./src/common/Services.test.js